import React from 'react';
import { FlightNumberColumn } from './FlightNumberColumn';
import { TimeColumn } from './TimeColumn';
import { GateColumn } from './GateColumn';
import { BaggageClaimColumn } from './BaggageClaimColumn';

interface IDetailInfoProps {
	codeShareFlightNumber: string;
	bestKnownTimestamp: number;
	scheduledTimestamp: number;
	gate: string;
	arrival: boolean;
	isDelayed: boolean;
	baggageBelt: string[];
}

export const FlightDetailColumns = ({
	bestKnownTimestamp,
	codeShareFlightNumber,
	arrival,
	gate,
	baggageBelt,
	isDelayed,
	scheduledTimestamp,
}: IDetailInfoProps) => {
	const baggageClaim =
		baggageBelt && baggageBelt.length ? baggageBelt.join(', ') : undefined;
	const columnWidth = baggageClaim ? 2 : 3;

	return (
		<>
			<FlightNumberColumn
				codeShareFlightNumber={codeShareFlightNumber}
				columns={[columnWidth, { mobileXL: 12 }]}
			/>

			<TimeColumn
				isDelayed={isDelayed}
				scheduledTimestamp={scheduledTimestamp}
				bestKnownTimestamp={bestKnownTimestamp}
				arrival={arrival}
				columns={[columnWidth, { mobileXL: 12 }]}
			/>

			<GateColumn gate={gate} columns={[columnWidth, { mobileXL: 12 }]} />

			{!baggageClaim ? null : (
				<BaggageClaimColumn
					baggageClaim={baggageClaim}
					columns={[columnWidth, { mobileXL: 12 }]}
				/>
			)}
		</>
	);
};
